// Hero.jsx — sección hero, variantes nocturna (cinemática) y documental (día).

import React from 'react'
import { trackCta } from '../../lib/analytics.js'
import { WordmarkImg } from '../CampaignMediaImg.jsx'
import { MetaCounter } from '../shared.jsx'
import { Scene } from './Scene.jsx'

// ──────────────────────────────────────────────────────────────────
// Hero — variante nocturna (cinemática)
// ──────────────────────────────────────────────────────────────────
function HeroNight({ campaign, onScrollTo, theme = "night" }) {
  const pct = campaign.raised / campaign.goal;
  return (
    <section id="top" style={{ paddingTop: 48, paddingBottom: 80 }}>
      <div className="wrap">
        <div
          className="hero-grid"
          style={{ display: "grid", gridTemplateColumns: "1.05fr 0.95fr", gap: 56, alignItems: "center" }}
        >
          {/* Columna izquierda — copy */}
          <div className="fade-up">
            <div className="eyebrow" style={{ marginBottom: 22 }}>
              <span className="dot" />
              Campaña activa · meta $800.000.000
            </div>
            <WordmarkImg
              theme={theme}
              style={{ width: "100%", maxWidth: 640, height: "auto", display: "block", marginBottom: 28 }}
            />
            <p className="lead" style={{ marginBottom: 20, fontSize: 18 }}>
              Quilpué no tiene una escala mecánica. Desde el año 2014, los bomberos voluntarios
              atienden emergencias <span style={{ color: "var(--alert)", fontWeight: 700 }}>sin cobertura aérea</span>.
              Han pasado más de 10 años y la ciudad sigue creciendo en pisos.
            </p>
            <p className="lead" style={{ marginBottom: 20 }}>
              Tu donación va <span className="accent">directamente</span> a la adquisición de un carro de Bomberos tipo “escala mecánica”
              una herramienta crítica para rescatar personas en altura, controlar incendios residenciales e industriales que requieren
              gran caudal de agua a distancia, asistir trabajos en techos y, también, rescatar animales atrapados en zonas elevadas.
              Devolverle a Quilpué la capacidad de responder donde hoy no llegamos es una necesidad.
            </p>

            <MetaCounter
              raised={campaign.raised}
              goal={campaign.goal}
              progress={campaign.progress}
              donors={campaign.donors}
              daysLeft={campaign.daysLeft}
            />

            <div style={{ display: "flex", gap: 12, marginTop: 32, flexWrap: "wrap" }}>
              <button
                className="btn btn-primary btn-lg"
                onClick={() => {
                  trackCta("hero_donar")
                  onScrollTo("como")
                }}
              >
                Donar ahora
              </button>
              <button className="btn btn-ghost btn-lg" onClick={() => onScrollTo("por-que")}>
                ¿Por qué importa? ↓
              </button>
            </div>
          </div>

          {/* Columna derecha — la escena */}
          <div className="fade-up delay-1">
            <Scene
              progress={pct}
              lastDonor={campaign.lastDonor}
              theme="night"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

// ──────────────────────────────────────────────────────────────────
// Hero — variante documental (modo día, editorial)
// ──────────────────────────────────────────────────────────────────
function HeroDay({ campaign, onScrollTo, theme = "day" }) {
  const pct = campaign.raised / campaign.goal;
  return (
    <section id="top" style={{ paddingTop: 48, paddingBottom: 64 }}>
      <div className="wrap">
        <div className="fade-up" style={{ textAlign: "center", marginBottom: 32 }}>
          <div className="eyebrow" style={{ justifyContent: "center" }}>
            <span className="dot" />
            Cuerpo de Bomberos de Quilpué · Fundado 1925
          </div>
        </div>

        <div className="fade-up" style={{ display: "flex", justifyContent: "center", marginBottom: 24 }}>
          <WordmarkImg
            theme={theme}
            style={{ width: "100%", maxWidth: 720, height: "auto", display: "block" }}
          />
        </div>

        <p className="lead fade-up delay-1" style={{ margin: "0 auto 56px", textAlign: "center", fontSize: 19, maxWidth: 680 }}>
          Quilpué no tiene escala mecánica desde hace más de una década. Una ciudad de
          <strong> más de 350.000 personas</strong> depende hoy del apoyo de comunas vecinas.
        </p>

        <div
          className="hero-grid fade-up delay-2"
          style={{ display: "grid", gridTemplateColumns: "0.9fr 1.1fr", gap: 40, alignItems: "stretch" }}
        >
          <div>
            <Scene progress={pct} lastDonor={campaign.lastDonor} theme="day" />
          </div>
          <div className="card-elev" style={{ padding: 32, display: "flex", flexDirection: "column", gap: 24, justifyContent: "center" }}>
            <MetaCounter
              raised={campaign.raised}
              goal={campaign.goal}
              progress={campaign.progress}
              donors={campaign.donors}
              daysLeft={campaign.daysLeft}
            />
            <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
              <button
                className="btn btn-primary btn-lg"
                onClick={() => {
                  trackCta("hero_donar")
                  onScrollTo("como")
                }}
              >
                Donar ahora
              </button>
              <button className="btn btn-ghost btn-lg" onClick={() => onScrollTo("por-que")}>
                ¿Por qué importa?
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export { HeroNight, HeroDay };
